import React, { Component } from "react";
import { push } from "react-router-redux";
import { connect } from "react-redux";
import { func, arrayOf, shape, string, bool, oneOfType, oneOf } from "prop-types";

import { actions as servicePaymentsActions, selectors as servicePaymentsSelectors } from "reducers/servicePayments";
import { selectors as sessionSelectors } from "reducers/session";
import { selectors as statusSelectors } from "reducers/status";
import { resolveServicePaymentsExitHref } from "util/servicePaymentsExitNavigation";
import * as i18n from "util/i18n";

import Head from "pages/_components/Head";
import Notification from "pages/_components/Notification";
import Button from "pages/_components/Button";
import { agendaPagoShape } from "util/servicePayments";
import { getServicePaymentsPath, isUxPaymentsServicesImprovementsEnabled } from "util/servicePaymentsRoutes";
import PageLoading from "pages/_components/PageLoading";
import ContextMenu from "pages/_components/ContextMenu";
import InfoTag from "pages/_components/InfoTag";
import {
    applyEmbeddedV3ShellLayoutState,
    clearEmbeddedV3ShellLayoutState,
    isUxDashboardImprovementsEnabled,
} from "util/v3ShellLayoutSync";
import { Hint } from "@ui-kit/components/index.es";
import AgendaDetailPaymentInfo from "../_components/AgendaDetailPaymentInfo";

const FORM_ID = "services.newPayment";

class MultiplePaymentAgendaDetail extends Component {
    static propTypes = {
        dispatch: func.isRequired,
        agendaPagos: arrayOf(agendaPagoShape).isRequired,
        match: shape({
            params: shape({ key: string.isRequired }),
        }).isRequired,
        location: shape({
            pathname: string.isRequired,
        }).isRequired,
        moduleEntryPath: oneOfType([string, oneOf([null])]),
        lastPathname: string.isRequired,
        isDesktop: bool,
        embeddedInV3Shell: bool,
        activeEnvironment: shape({
            permissions: shape({
                newPayment: bool,
            }),
        }).isRequired,
    };

    static defaultProps = {
        isDesktop: false,
        embeddedInV3Shell: false,
        moduleEntryPath: null,
    };

    componentDidMount() {
        const { dispatch } = this.props;

        dispatch(servicePaymentsActions.listAgendaPagos());
        this.syncEmbeddedV3ShellLayout();
    }

    componentDidUpdate(prevProps) {
        const { embeddedInV3Shell, isDesktop, agendaPagos, moduleEntryPath, lastPathname } = this.props;
        if (
            embeddedInV3Shell &&
            (prevProps.embeddedInV3Shell !== embeddedInV3Shell ||
                prevProps.isDesktop !== isDesktop ||
                prevProps.agendaPagos !== agendaPagos ||
                prevProps.moduleEntryPath !== moduleEntryPath ||
                prevProps.lastPathname !== lastPathname)
        ) {
            this.syncEmbeddedV3ShellLayout();
        }
    }

    componentWillUnmount() {
        const { dispatch, embeddedInV3Shell } = this.props;
        if (embeddedInV3Shell) {
            clearEmbeddedV3ShellLayoutState(dispatch);
        }
    }

    syncEmbeddedV3ShellLayout = () => {
        const { dispatch, embeddedInV3Shell, isDesktop } = this.props;
        const agendaPago = this.getAgendaPago();
        const title = agendaPago?.entity?.description;
        applyEmbeddedV3ShellLayoutState(dispatch, {
            embeddedInV3Shell,
            isDesktop,
            scopes: ["servicePayments"],
            goBackPath: getServicePaymentsPath(),
            ...(title ? { headerTitle: title } : { titleKey: "menu.payments.payServices" }),
            rightContentMobile: !isDesktop && agendaPago ? this.rightContent() : undefined,
        });
    };

    resolveExitHref = () => {
        const { moduleEntryPath, lastPathname, location } = this.props;
        return resolveServicePaymentsExitHref({
            moduleEntryPath,
            lastPathname,
            currentPathname: location.pathname,
        });
    };

    handleBack = () => {
        const { dispatch } = this.props;
        dispatch(push(getServicePaymentsPath()));
        dispatch(servicePaymentsActions.setModuleEntryPath(null));
    };

    handlePayment = () => {
        const { dispatch } = this.props;
        const agendaPago = this.getAgendaPago();

        dispatch(servicePaymentsActions.loadSummaryInfo(agendaPago));
        dispatch(push(`/agenda/payment`));
    };

    handleUnattachService = () => {
        const { dispatch } = this.props;
        const agendaPago = this.getAgendaPago();
        const adhesion = {
            adhesionCode: agendaPago?.codeAdherence,
            enteDescription: agendaPago?.entity.description,
            enteCode: agendaPago?.entity.code,
            userLp: agendaPago?.ususerLP,
            category: agendaPago?.entity.category,
            reference: agendaPago?.reference,
            manejaBaseDeuda: agendaPago?.entity.handleBaseDebts,
        };
        dispatch(servicePaymentsActions.loadSummaryInfo(adhesion));
        dispatch(push(`/desadherir/confirmation`));
    };

    getAgendaPago = () => {
        const { agendaPagos } = this.props;
        const {
            match: {
                params: { key: keyParam },
            },
        } = this.props;
        return agendaPagos.find((pago) => pago.key === keyParam);
    };

    rightContent = () => {
        const { agendaPagos, isDesktop, activeEnvironment } = this.props;
        const agendaPago = agendaPagos ? this.getAgendaPago() : null;

        if (isDesktop) {
            return (
                agendaPago && (
                    <>
                        {activeEnvironment.permissions.newPayment && !agendaPago.isPending ? (
                            <Button
                                block
                                label="payments.afip.list.actions.pay"
                                bsStyle="primary"
                                className="cmf-button-width"
                                onClick={this.handlePayment}
                            />
                        ) : (
                            undefined
                        )}
                        {agendaPago?.entity?.handleBaseDebts && (
                            <Button
                                block
                                label="services.adhesiones.table.header.unattachService"
                                onClick={this.handleUnattachService}
                                className="btn-outline cmf-button-width"
                            />
                        )}
                    </>
                )
            );
        }

        const items = [];

        if (activeEnvironment.permissions.newPayment && !agendaPago.isPending) {
            items.push({
                label: "payments.afip.list.actions.pay",
                onClick: () => this.handlePayment(),
            });
        }

        if (agendaPago?.entity?.handleBaseDebts) {
            items.push({
                label: "services.adhesiones.table.header.unattachService",
                onClick: () => this.handleUnattachService(),
            });
        }

        return (
            <div>
                <ContextMenu className="justify-content-end" color="white" items={items} />
            </div>
        );
    };

    /**
     * Renders the pending-payment status badge (Hint or legacy InfoTag).
     * @returns {React.ReactNode|null}
     */
    renderPendingStatus = () => {
        if (isUxPaymentsServicesImprovementsEnabled()) {
            return (
                <Hint colorText="dark" colorIcon="dark" text={i18n.get("services.payments.detail.status.PENDING")} />
            );
        }

        return (
            <InfoTag
                type="info"
                message={i18n.get(`services.payments.detail.status.PENDING`)}
                tagBackground="#FFE5B6"
                tagClass="max-width-mincontent px-2 text-nowrap"
                moreStyles={{
                    color: "black",
                }}
            />
        );
    };

    headerContentDesktop = () => {
        const { agendaPagos } = this.props;
        const agendaPago = agendaPagos ? this.getAgendaPago() : null;

        return (
            <div className="view-title d-flex align-items-center">
                <h1>{agendaPago?.entity?.description}</h1>
                {agendaPago?.isPending && <div className="ml-3">{this.renderPendingStatus()}</div>}
            </div>
        );
    };

    render() {
        const { agendaPagos, isDesktop, embeddedInV3Shell } = this.props;
        const agendaPago = agendaPagos ? this.getAgendaPago() : null;
        const showEmbeddedShellHeader = embeddedInV3Shell && isUxDashboardImprovementsEnabled() && !isDesktop;

        return (
            <PageLoading loading={!agendaPago?.concept && !agendaPago?.expiration}>
                {!embeddedInV3Shell && <Notification scopeToShow="servicePayments" />}
                {isDesktop ? (
                    <div className="admin-detail-head px-0 mb-0">
                        <Head onBack={this.handleBack} />
                        <Head
                            centerElement={this.headerContentDesktop}
                            rightContent={this.rightContent}
                            isFetchingExport={false}
                        />
                        <p>
                            {`${agendaPago?.entity?.category?.description?.toUpperCase()}`} |{" "}
                            {`${agendaPago?.reference?.toUpperCase()}`}
                        </p>
                    </div>
                ) : (
                    !showEmbeddedShellHeader && (
                        <div className="admin-detail-head px-0 mb-0">
                            <Head
                                onBack={this.handleBack}
                                titleText={agendaPago?.entity?.description}
                                titleClassName="my-0"
                                centerContentClassName="mx-5"
                                rightContent={this.rightContent}
                                isFetchingExport={false}
                                headerClassName="blue-main-header-mobile payment-title-mobile"
                            />
                            <div className="d-flex mb-3 mx-3">
                                <div className="w-50 text-right">{`${agendaPago?.entity?.category?.description?.toUpperCase()}`}</div>
                                <div className="border-left mx-2" />
                                <div className="w-50 text-left">{`${agendaPago?.reference?.toUpperCase()}`}</div>
                            </div>
                            {agendaPago?.isPending && <div className="ml-3">{this.renderPendingStatus()}</div>}
                        </div>
                    )
                )}
                <AgendaDetailPaymentInfo
                    FORM_ID={FORM_ID}
                    agendaPago={agendaPago}
                    handleBack={this.handleBack}
                    isDesktop={isDesktop}
                />
            </PageLoading>
        );
    }
}

const mapStateToProps = (state) => ({
    agendaPagos: servicePaymentsSelectors.getFlatPayments(state),
    activeEnvironment: sessionSelectors.getActiveEnvironment(state),
    moduleEntryPath: servicePaymentsSelectors.getModuleEntryPath(state),
    lastPathname: statusSelectors.getPathname(state),
});

export default connect(mapStateToProps)(MultiplePaymentAgendaDetail);
